module.exports = __webpack_public_path__ + "assets/img/exchange_success.835341c2.png";